import { render, staticRenderFns } from "./ChainEdit.vue?vue&type=template&id=03db6e76"
import script from "./ChainEdit.vue?vue&type=script&lang=js"
export * from "./ChainEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports